export const NON_OFFICIAL_FILIERE = 'nonOfficialFiliere';
export const NON_OFFICIAL_GRADE = 'nonOfficialGrade';
export const OFFICIAL_GRADE = 'officialGrade';
